import React from 'react'

export default function NotFound(){
    return(
        <section className='NotFoundPage'>
        <h2>404 - Page not found</h2>
        <p>Try going back to your previous page.</p>
      </section>
    )
};